import * as svg from "../../../assets/user-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const UserIcon = iconBuilder(svg, "UserIcon", "0 0 17 17");
